import { setCustomer } from "@/redux/ducks/customer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const LoggedMenu = ({
  isShowingMenu,
  toggleMenu,
}: {
  isShowingMenu: boolean;
  toggleMenu: () => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isShowingMenu) {
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
    }
  }, [isShowingMenu]);

  const handleMenuClick = (path: string) => {
    toggleMenu();
    navigate(path);
  };

  const logout = () => {
    dispatch(
      setCustomer({
        accessToken: undefined,
        refreshToken: undefined,
        customer: undefined,
        account: undefined,
        client: undefined,
        products: undefined,
        vehicles: undefined,
        extract: undefined,
        recharges: undefined,
        pinDevice: undefined,
        isLoadingVehicles: false,
        selectedVehicles: undefined,
        tickets: undefined,
        debts: undefined,
      }),
    );
    toggleMenu();
  };

  if (!isShowingMenu) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40">
      <button className="absolute inset-0" onClick={toggleMenu} />

      <div className="flex justify-center ">
        <div
          className={`
            relative bg-white rounded-2xl shadow-lg w-full sm:max-w-sm m-2
            transform transition-all duration-300 ease-out
            ${isVisible ? "translate-y-0 opacity-100" : "-translate-y-8 opacity-0"}
          `}
        >
          {/* Menu items */}
          <div className="p-4 space-y-1">
            {/* Close button */}
            <div className="flex justify-end mb-4">
              <button
                onClick={toggleMenu}
                className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <img
                  src="/svg/icon-close.svg"
                  width="24"
                  height="24"
                  alt="Fechar"
                />
              </button>
            </div>
            <button
              className="w-full text-left py-3 text-gray-800 font-medium hover:bg-gray-50 rounded-lg px-2 transition-colors"
              onClick={() => handleMenuClick("/mydata")}
            >
              Meus dados
            </button>

            <button
              className="w-full text-left py-3 text-gray-800 font-medium hover:bg-gray-50 rounded-lg px-2 transition-colors"
              onClick={() => handleMenuClick("/ticket")}
            >
              Meus recibos
            </button>

            <button
              className="w-full text-left py-3 text-gray-800 font-medium hover:bg-gray-50 rounded-lg px-2 transition-colors"
              onClick={() => handleMenuClick("/myvehicles")}
            >
              Meus veículos
            </button>

            <button
              className="w-full text-left py-3 text-gray-800 font-medium hover:bg-gray-50 rounded-lg px-2 transition-colors"
              onClick={() => handleMenuClick("/password")}
            >
              Alterar senha
            </button>

            <button
              className="w-full text-left py-3 text-gray-800 font-medium hover:bg-gray-50 rounded-lg px-2 transition-colors"
              onClick={() => handleMenuClick("/faq")}
            >
              Perguntas frequentes
            </button>

            <div className="border-t border-gray-200 pt-2 mt-4">
              <button
                className="w-full text-left py-3 text-gray-800 font-medium hover:bg-gray-50 rounded-lg px-2 transition-colors"
                onClick={logout}
              >
                Sair
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoggedMenu;
